import axios, { AxiosInstance } from "axios";
import { LOCATION_SERVER_URL } from "constants/api-constants";
import { authInterceptor } from "./authInterceptor";

const locationClient: AxiosInstance = axios.create({
  baseURL: LOCATION_SERVER_URL,
});

locationClient.interceptors.request.use(
  authInterceptor("syi:access-token"),
  (er) => {
    return Promise.reject(er);
  }
);

export default locationClient;
